export enum ChargebackCostAllocationEnum {
  DEDUCT_FROM_LIABLE_ACCOUNT = 'deductFromLiableAccount', // TENANT_PAY
  DEDUCT_FROM_ONE_BALANCE_ACCOUNT = 'deductFromOneBalanceAccount', // MERCHANT_PAY
}

export enum RefundSplitEnum {
  DEDUCT_ACCORDING_TO_SPLIT_RATIO = 'deductAccordingToSplitRatio', // REVERSE_PAYMENT_SPLIT
  DEDUCT_FROM_LIABLE_ACCOUNT = 'deductFromLiableAccount', // not used on our side
  DEDUCT_FROM_ONE_BALANCE_ACCOUNT = 'deductFromOneBalanceAccount', // MERCHANT_PAY
}

export enum RefundCostAllocationEnum {
  DEDUCT_FROM_LIABLE_ACCOUNT = 'deductFromLiableAccount', // TENANT_PAY
  DEDUCT_FROM_ONE_BALANCE_ACCOUNT = 'deductFromOneBalanceAccount', // MERCHANT_PAY
}

export enum PaymentFeeEnum {
  DEDUCT_FROM_LIABLE_ACCOUNT = 'deductFromLiableAccount', // FLAT
  DEDUCT_FROM_ONE_BALANCE_ACCOUNT = 'deductFromOneBalanceAccount', // COST_PLUS
}

export enum FundingSourceEnum {
  ANY = 'ANY',
  CREDIT = 'credit',
  DEBIT = 'debit',
  PREPAID = 'prepaid',
  DEFERRED_DEBIT = 'deferred_debit',
  CHARGED = 'charged',
}
